import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEmploymentPlans } from '../../../../../../global/ducks/benadmin-api';
import { TcsmStates } from '../../../../../../root/tcsm-model';
import { setNewHireEnrollmentMemberPensionInfo } from '../../slice/new-hire-enrollment-slices';

export function useMemberPensionEnrollmentInfo() {
    const dispatch = useDispatch();
    
    const memberPensionInfoLoaded = useSelector<TcsmStates, boolean>(state => state?.newHireEnrollmentState?.memberPensionInfoLoaded);

    const memberCurrentEmploymentId = useSelector<TcsmStates, number>(state => state?.newHireEnrollmentState?.memberCurrentEmploymentId);
    const memberCurrentEmploymentIdLoaded = useSelector<TcsmStates, boolean>(state => state?.newHireEnrollmentState?.memberCurrentEmploymentIdLoaded);
    const personGuid = useSelector<TcsmStates, string>(state => state?.authenticatedState?.clientGuid);    

    useEffect(() => {
        if (memberCurrentEmploymentIdLoaded && memberCurrentEmploymentId  && !memberPensionInfoLoaded && personGuid) {            
            dispatch(getEmploymentPlans(
                memberCurrentEmploymentId,                
                (response)=>{                    
                    dispatch(setNewHireEnrollmentMemberPensionInfo(response));
                })); 
        }
    }, [memberCurrentEmploymentId, personGuid]);

    return memberCurrentEmploymentIdLoaded && memberPensionInfoLoaded;
}